var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "boss-main-container" }, [
    _c(
      "div",
      { staticClass: "boss-main-wrap boss-main-content-wrap" },
      [
        _c("setting-header", {
          attrs: {
            breadcrumbs: [{ name: "各種設定" }],
            title: "スカウト＿一覧画面の表示情報の設定",
          },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "boss-selection-container clearfix" }, [
          _c("div", { staticClass: "boss-selection-wrap" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "boss-selection-resume-right" }, [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "ul",
                {
                  staticClass: "boss-select-list-resume pega-clear-padding",
                  attrs: { "data-test": "selected-item" },
                },
                [
                  _vm.isDragging
                    ? _c(
                        "div",
                        {
                          staticClass: "pega-drop-area top",
                          attrs: { "data-test": "drop-area" },
                        },
                        [
                          _c("p", [
                            _vm._v("↓ この範囲に要素をドラッグしてください"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "pega-drag-area",
                      attrs: {
                        group: "items",
                        "data-test": "draggable-selected",
                      },
                      on: {
                        start: _vm.changeDragging,
                        end: _vm.changeDragging,
                      },
                      model: {
                        value: _vm.selectedItems,
                        callback: function ($$v) {
                          _vm.selectedItems = $$v
                        },
                        expression: "selectedItems",
                      },
                    },
                    _vm._l(_vm.selectedItems, function (item) {
                      return _c(
                        "li",
                        { key: item.id, staticClass: "boss-select-item" },
                        [
                          _c("span", {
                            staticClass: "boss-select-item-text",
                            domProps: { innerHTML: _vm._s(item.name) },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isDragging
                    ? _c(
                        "div",
                        {
                          staticClass: "pega-drop-area bottom",
                          attrs: { "data-test": "drop-area" },
                        },
                        [
                          _c("p", [
                            _vm._v("↑ この範囲に要素をドラッグしてください"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm._m(2),
          _vm._v(" "),
          _c("div", { staticClass: "boss-select-container" }, [
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "boss-select-wrap" }, [
              _c(
                "ul",
                {
                  staticClass: "boss-select-list pega-clear-padding",
                  attrs: { "data-test": "unselected-item" },
                },
                [
                  _vm.isDragging
                    ? _c(
                        "div",
                        {
                          staticClass: "pega-drop-area top",
                          attrs: { "data-test": "drop-area" },
                        },
                        [
                          _c("p", [
                            _vm._v("↓ この範囲に要素をドラッグしてください"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "draggable",
                    {
                      staticClass: "pega-drag-area",
                      attrs: {
                        group: "items",
                        "data-test": "draggable-unselected",
                      },
                      on: {
                        start: _vm.changeDragging,
                        end: _vm.changeDragging,
                      },
                      model: {
                        value: _vm.unselectedItems,
                        callback: function ($$v) {
                          _vm.unselectedItems = $$v
                        },
                        expression: "unselectedItems",
                      },
                    },
                    _vm._l(_vm.unselectedItems, function (item) {
                      return _c(
                        "li",
                        { key: item.id, staticClass: "boss-select-item" },
                        [
                          _c("span", {
                            staticClass: "boss-select-item-text",
                            domProps: { innerHTML: _vm._s(item.name) },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.isDragging
                    ? _c(
                        "div",
                        {
                          staticClass: "pega-drop-area bottom",
                          attrs: { "data-test": "drop-area" },
                        },
                        [
                          _c("p", [
                            _vm._v("↑ この範囲に要素をドラッグしてください"),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "form-button-area",
          [
            _c("form-back-button", {
              attrs: { "data-test": "back-button" },
              on: {
                back: function ($event) {
                  return _vm.$router.back()
                },
              },
            }),
            _vm._v(" "),
            _c("form-confirm-button", {
              attrs: {
                "submit-label": "登録する",
                "data-test": "confirm-button",
              },
              on: { "submit-event": _vm.updateDisplayItems },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-selection-resume-left" }, [
      _c("span", { staticClass: "boss-userid-text boss-position-reset" }, [
        _vm._v("ID:サンプル"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "boss-resumecard-item-left-item" }, [
        _c("div", { staticClass: "boss-avatar" }, [
          _c("img", {
            staticClass: "boss-avatar-image",
            attrs: {
              src: require("@/assets/images/boss-avatar.svg"),
              alt: "90日以上無し",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "boss-latest-action" }, [
          _c("div", { staticClass: "boss-resumecard-head" }, [
            _vm._v("\n                最終ログイン\n              "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-resumecard-date" }, [
            _vm._v("\n                -\n              "),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "boss-another-scout" }, [
          _c("div", { staticClass: "boss-resumecard-head" }, [
            _vm._v("\n                他社からのスカウト\n              "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "boss-resumecard-date" }, [
            _vm._v("\n                -\n              "),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [_vm._v("標準項目")]),
      _vm._v(" "),
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v(
          "年齢・性別・現住所・就業状況・現在（直近）の年収・転職回数・直近の経験職種・希望職種・希望勤務地"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-center-container" }, [
      _c("div", { staticClass: "boss-arrow" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "boss-select-title" }, [
      _c("span", { staticClass: "boss-select-text" }, [
        _vm._v("表示したい項目を右枠から左枠にドラッグしてください。"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }